/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dry_Few_Duck_BorrowInputs */

const fr_dry_few_duck_borrow = /** @type {(inputs: Dry_Few_Duck_BorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer un programme`)
};

/**

* @param {Dry_Few_Duck_BorrowInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const dry_few_duck_borrow = /** @type {((inputs?: Dry_Few_Duck_BorrowInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dry_Few_Duck_BorrowInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_dry_few_duck_borrow(inputs)
});